<template>
  <generic-modal :title="$t('recurring event')" ref="generic_modal">
    <div>
      <div class="title is-4">{{ day }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("start time") }}</label>
            <div class="select">
              <select v-model="meta.start">
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("practice length") }}</label>
            <div class="select">
              <select v-model="meta.practice_length">
                <option value="45">45 {{ $t("minutes") }}</option>
                <option value="90">90 {{ $t("minutes") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("coach") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.coach"
                placeholder="Luis Robledo"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("maximum capacity") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.maximum_capacity"
                placeholder="16"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="field">
            <label class="label">{{ $t("photo") }}</label>
            <div class="control">
              <generic-uploader
                ref="generic_uploader"
                :idle_label="$t('drop photo here or click to upload')"
                endpoint_url="/pilates_member/calendar/coach-photo"
                @error="error_uploading"
                @success="success_uploading"
                :allow_multiple="false"
              />
            </div>
            <!-- <pre>{{ meta }}</pre> -->
          </div>
        </div>
        <div class="column">
          <figure class="image is-128x128">
            <v-lazy-image
              v-if="meta.settings && meta.settings.coach_photo"
              :src="`${api_host}/drive/static/${meta.settings.coach_photo.final_name}`"
            />
            <img
              v-else
              src="https://cdn-icons-png.flaticon.com/512/6833/6833573.png"
            />
          </figure>
        </div>
      </div>
      <div class="title is-5">
        {{ $t("assistants") }}
      </div>
      <div class="tags" v-if="assistants.length">
        <span
          class="tag is-large is-primary"
          v-for="(assistant, aidx) in assistants"
          :key="aidx"
        >
          {{ assistant.pilates_member.name }}
          <div class="delete" @click="delete_booking(assistant.uuid)"></div>
        </span>
      </div>
      <article class="message is-info" v-else>
        <div class="message-body">
          {{ $t("no reserve has been made yet") }}
        </div>
      </article>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta && meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  confirm_deletion_dialog,
  format_date,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";
import { v4 } from "uuid";
import VLazyImage from "v-lazy-image";

export default {
  name: "RecurringEventModal",
  components: { GenericModal, GenericCalendar, GenericUploader, VLazyImage },
  data() {
    let v = this;
    return {
      api_host,
      meta: {},
      event_info: {},
      error: "",
      assistants: [],
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.date ||
        !v.meta.start ||
        !v.meta.practice_length ||
        !v.meta.coach
      );
    },
    day() {
      let v = this;
      return v.$t(moment(v.event_info.date).format("dddd"));
    },
  },
  methods: {
    moment,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(event_info) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.event_info = event_info;
      v.meta.date = event_info.date;
      v.meta.start = moment(event_info.date).format("HH:mm");
    },
    save() {
      let v = this;
      if (!v.meta.uuid) {
        put("/pilates_member/calendar", {
          ...v.meta,
        })
          .then((r) => {
            v.$emit("updated", r);
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/pilates_member/calendar", {
          ...v.meta,
        })
          .then((r) => {
            v.$emit("updated", r);
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        practice_length: 45,
        coach: "",
        maximum_capacity: 16,
        settings: { coach_photo: undefined },
        date: "",
        start: "",
      };
      v.assistants = [];
      v.start_time = "";
      v.event_info = {};
      v.error = "";
      v.availability_checked = false;
      v.$refs.generic_uploader.clear();
      // v.available_stations = [];
      v.booking = {};
      // v.uuid = "";
    },
    date_changed(date) {
      let v = this;
      v.meta.date = moment(date).toISOString();
    },
    edit_modal(event_uuid, date) {
      let v = this;
      v.$refs.generic_modal.show_modal();
      v.event_info = { date: date };
      get("/pilates_member/calendar/class", { uuid: event_uuid, date: date })
        .then((event) => {
          v.meta.uuid = event.uuid;
          if (event.coach) v.meta.coach = event.coach;
          if (event.maximum_capacity)
            v.meta.maximum_capacity = event.maximum_capacity;
          if (event.start_date) {
            v.meta.date = moment(event.start_date);
            v.meta.start = moment(event.start_date).format("HH:mm");
          }
          if (event.end_date) {
            v.meta.practice_length = moment(event.end_date).diff(
              moment(event.start_date),
              "minutes"
            );
          }

          if (event.pilates_bookings) {
            v.assistants = event.pilates_bookings;
          }

          if (event.settings && event.settings.coach_photo) {
            if (v.meta.settings)
              v.meta.settings.coach_photo = event.settings.coach_photo;
            else v.meta.settings = { coach_photo: event.settings.coach_photo };
          }
        })
        .catch((error) => {
          console.error("error", error);
          v.error = generate_error_message_text(error);
        });
      // v.meta = {
      //   uuid: event.id,
      //   date: event.start,
      //   start: moment(event.start).format("HH:mm"),
      //   practice_length: 90,
      //   coach: event.title.split(" | ")[0],
      //   maximum_capacity: event.title.split(" | ")[1],
      // };
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete event?"), v, () => {
        del("/pilates_member/calendar", { uuid: v.meta.uuid })
          .then(() => {
            v.$emit("updated");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      });
    },
    delete_booking(booking_uuid) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete booking?"),
        v,
        () => {
          del("/pilates_member/calendar/booking", { uuid: booking_uuid })
            .then(() => {
              v.assistants = v.assistants.filter(
                (a) => a.uuid !== booking_uuid
              );
              v.$emit("updated");
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
      };

      if (v.meta.settings) v.meta.settings.coach_photo = data;
      else v.meta.settings = { coach_photo: data };
    },
  },
  created() {
    let v = this;
    get("/pilates_member/calendar/available-stations", {})
      .then((available_stations) => {
        v.available_stations = available_stations;
      })
      .catch((error) => {
        v.error = generate_error_message_text(error);
      });
  },
  watch: {},
};
</script>
<style></style>
